export default __webpack_public_path__ + "static/media/wide_curl_end.6ab9663c.svg";